// Temporary redirect for bookmarks created before the tax-binder rename.
// /preparer/binder/$binderId/audit-logs → /preparer/tax-binders/$binderId/audit-logs.
// Remove approximately 6 weeks after release (around 2026-06-15).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/preparer/binder/$binderId/audit-logs')({
  beforeLoad: ({ params: { binderId } }) => {
    throw redirect({
      to: '/preparer/tax-binders/$binderId/audit-logs',
      params: { binderId },
      replace: true,
    });
  },
  component: () => null,
});
